import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/images/amblem_light.png";
import ios from "../../assets/mobil/ios.png";
import google from "../../assets/mobil/google.png";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={logo} alt="Metal Kıymetli Madenler Logo" className="footer-logo" />
        </div>
        <div className="footer-right">
          <div className="footer-menu">
            <Link to="/" className="footer-menu-item">Ana Sayfa</Link>
            <Link to="/about" className="footer-menu-item">Hakkımızda</Link>
            <Link to="/products" className="footer-menu-item">Ürünlerimiz</Link>
            <Link to="/contact" className="footer-menu-item">İletişim</Link>
          </div>
          <p className="footer-text">
            AIFASOFT © 2024 Tüm hakları saklıdır.
          </p>
          <p className="footer-info">
            Tüm kurlar bilgi amaçlıdır ve piyasa verileri Foreks Hizmetleri tarafından sağlanmaktadır.
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/tr/app/metal-k%C4%B1ymetli-madenler/id6741539880?l=tr" target="_blank" rel="noopener noreferrer">
              <img src={ios} alt="App Store" className="store-icon" />
            </a>
            <a href="https://apps.apple.com/tr/app/metal-k%C4%B1ymetli-madenler/id6741539880?l=tr" target="_blank" rel="noopener noreferrer">
              <img src={google} alt="Google Play" className="store-icon" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;